import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { ArchitectureDiagram } from '../components/ArchitectureDiagram';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
export function HomeArchitecture() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-4496" />
      <ArchitectureDiagram data-id="element-4497" />
      <HowItWorksConnections mode="how" data-id="element-4498" />
      <LivesInSlack data-id="element-4499" />
      <ComputerUse data-id="element-4500" />
      <CapabilityGrid data-id="element-4501" />
      <NarrativeSection data-id="element-4502" />
      <ToolComparison data-id="element-4503" />
      <WallOfLove data-id="element-4504" />
      <PricingSection data-id="element-4505" />
      <ClosingCTA data-id="element-4506" />
    </>;
}